import { User } from './user-data-store';

export const fullName = (user: User) => `${user.firstName} ${user.lastName}`;
export const shortName = (user: User) => `${user.firstName} ${user.lastName.slice(0, 1)}.`;
